import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	fragment offersTable_QueryFragment on Query
	@refetchable(queryName: "offersTable_Refetch")
	@argumentDefinitions(
		first: { type: "Int", defaultValue: 20 }
		after: { type: "String" }
		last: { type: "Int" }
		before: { type: "String" }
		text: { type: "String" }
		tagIds: { type: "[ID!]!" }
		isVisible: { type: "Boolean" }
		kinds: { type: "[LearnableKind!]!" }
	) {
		Admin {
			Learnable {
				UnpublishedLearnables(
					first: $first
					after: $after
					last: $last
					before: $before
					text: $text
					tagIds: $tagIds
					isVisible: $isVisible
					kinds: $kinds
				) @connection(key: "offersTable_UnpublishedLearnables") {
					__id
					edges {
						node {
							id
							kind
							...offersTable_UnpublishedLearnableFragment
						}
					}
					pageInfo {
						startCursor
						endCursor
						hasNextPage
						hasPreviousPage
					}
				}
			}
		}
	}
`;

export const UNPUBLISHED_LEARNABLE_FRAGMENT = graphql`
	fragment offersTable_UnpublishedLearnableFragment on UnpublishedLearnable @inline {
		id
		kind
		... on UnpublishedCourseLearnable {
			root {
				id
				hasBeenPublishedOnce
				structureDefinition {
					title
				}
			}
		}
		...editCourseLearnableButton_UnpublishedLearnableFragment
		...deleteCourseLearnableButton_UnpublishedLearnableFragment
	}
`;
